import React from "react";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { FormatCurrencyRupiah } from "../../../../../Services/Utils";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import FlexView from "react-flexview";

export const getTableConfigBBM = ({ onSelect }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "nomorBBM",
    label: "Nomor BBM",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "20%" },
      }),
    },
  },
  {
    name: "tanggalBBM",
    label: "Tanggal BBM",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
    },
  },
  {
    name: "keterangan",
    label: "Keterangan",
    options: {
      sort: false,
    },
  },
  {
    name: "totalAmount",
    label: "Nilai BBM",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (val) => {
        return FormatCurrencyRupiah({ number: Number(val) });
      },
    },
  },
  {
    name: "nomorBBM",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (val) => {
        return (
          <React.Fragment>
            <SimpleButton
              styles={{ width: "unset" }}
              text="Pilih"
              onClick={() => onSelect(val)}
            />
          </React.Fragment>
        );
      },
    },
  },
];

export const getTableConfigBKKBBK = ({ tab, onSelect }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "nomorBbk",
    label: "Nomor BBK",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "20%" },
      }),
      display: tab === "bbk",
    },
  },
  {
    name: "nomorBkk",
    label: "Nomor BKK",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "20%" },
      }),
      display: tab === "bkk",
    },
  },
  {
    name: "tanggalBBM",
    label: "Tanggal BKK",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      display: tab === "bkk",
    },
  },
  {
    name: "tanggalBbk",
    label: "Tanggal BBK",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      display: tab === "bbk",
    },
  },
  {
    name: "keterangan",
    label: "Keterangan",
    options: {
      sort: false,
    },
  },
  {
    name: "totalAmount",
    label: `Nilai ${tab === "bbk" ? "BBK" : "BKK"}`,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (val) => {
        return FormatCurrencyRupiah({ number: Number(val) });
      },
    },
  },
  {
    name: "",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (_,tableMeta) => {
        const idx = tab === "bbk" ? 1 : 2
        const value = tableMeta.rowData[idx];
        return (
          <React.Fragment>
            <SimpleButton
              styles={{ width: "unset" }}
              text="Pilih"
              onClick={() => onSelect("nomorPembelian", value)}
            />
          </React.Fragment>
        );
      },
    },
  },
];

export const getTableConfigDataCustomer = ({ onSelect }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{rowNumber}</>;
      },
      sort: false,
    },
  },
  {
    name: "name",
    label: "Nama",
    options: {
      sort: false,
    },
  },
  {
    name: "noTelepon",
    label: "Telepon",
    options: {
      sort: false,
    },
  },
  {
    name: "nik",
    label: "NIK",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalLahir",
    label: "Tanggal Lahir",
    options: {
      sort: false,
    },
  },
  {
    name: "alamat",
    label: "Alamat",
    options: {
      sort: false,
    },
  },
  {
    name: "province",
    label: "Provinsi",
    options: {
      customBodyRender: (val) => <>{val?.label}</>,
      sort: false,
    },
  },
  {
    name: "kecamatan",
    label: "Kecamatan",
    options: {
      customBodyRender: (val) => <>{val?.label}</>,
      sort: false,
    },
  },
  {
    name: "kelurahan",
    label: "Kelurahan",
    options: {
      customBodyRender: (val) => <>{val?.label}</>,
      sort: false,
    },
  },
  {
    name: "",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (_,{rowIndex}) => {
        return (
          <React.Fragment>
            <SimpleButton
              styles={{ width: "unset" }}
              text="Pilih"
              onClick={() => onSelect(rowIndex)}
            />
          </React.Fragment>
        );
      },
    },
  },
];

export const getClaimPartTableConfig = ({
  onSaveData,
  onEditData,
  onDeleteData,
  onChangeData,
  options,
  isDisable,
}) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const pageNormalized = page > 0 ? page - 1 : 0;
        const name = tableMeta.rowData[2];
        if (name === "Total (Rp)") {
          return null;
        }
        return pageNormalized * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "kodePart",
    label: "Kode Part",
    options: {
      sort: false,
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        const name = tableMeta.rowData[2];
        if (name === "Total (Rp)") {
          return null;
        }
        if (isSaved) {
          return val?.value;
        }
        return (
          <SimpleDDL
            box="search"
            id="id_select_kode_part_management_claim"
            options={options?.map((item) => ({
              label: `${item.kodePart} - ${item.partName}`,
              value: item.kodePart,
              ...item,
            }))}
            name="kodePart"
            containerclassname="width width-250px"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            value={val}
            onChange={(value, { name }) => {
              onChangeData(tableMeta.rowIndex, name, value);
              onChangeData(tableMeta.rowIndex, "namaPart", {
                label: value.partName,
                value: value.partName,
              });
              onChangeData(tableMeta.rowIndex, "kategori", {
                label: value.partCategory,
                value: value.partCategory,
              });
              onChangeData(tableMeta.rowIndex, "het", value?.het || 0);
            }}
          />
        );
      },
    },
  },
  {
    name: "namaPart",
    label: "Nama Part",
    options: {
      sort: false,
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        if (val === "Total (Rp)") {
          return val;
        }
        if (isSaved) {
          return val?.value;
        }
        return (
          <SimpleDDL
            box="search"
            id="id_select_nama_part_management_claim"
            options={options?.map((item) => ({
              label: item.partName,
              value: item.partName,
              ...item,
            }))}
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            name="namaPart"
            containerclassname="width width-250px"
            value={val}
            onChange={(value, { name }) => {
              onChangeData(tableMeta.rowIndex, name, value);
              onChangeData(tableMeta.rowIndex, "kodePart", {
                ...value,
                label: `${value.kodePart} - ${value.partName}`,
                value: value.kodePart,
              });
              onChangeData(tableMeta.rowIndex, "kategori", {
                label: value.partCategory,
                value: value.partCategory,
              });
              onChangeData(tableMeta.rowIndex, "het", value?.het || 0);
            }}
          />
        );
      },
    },
  },
  {
    name: "kategori",
    label: "Kategori Part",
    options: {
      sort: false,
      customBodyRender: (val, tableMeta) => {
        const name = tableMeta.rowData[2];
        if (name === "Total (Rp)") {
          return null;
        }
        return val?.value || null;
      },
    },
  },
  {
    name: "qty",
    label: "Quantity",
    options: {
      sort: false,
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        const name = tableMeta.rowData[2];
        if (name === "Total (Rp)") {
          return null;
        }
        if (isSaved) {
          return val;
        }
        return (
          <SimpleInput
            id="id_input_qty_part_management_claim"
            box="number"
            containerclassname="width width-100px"
            value={val}
            onValueChange={({ value }) =>
              onChangeData(tableMeta.rowIndex, "qty", value)
            }
          />
        );
      },
    },
  },
  {
    name: "het",
    label: "HET (Rp)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "11%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const name = tableMeta.rowData[2];
        if (name === "Total (Rp)") {
          return null;
        }
        return val ? FormatCurrencyRupiah({ number: Number(val) }) : null;
      },
    },
  },
  {
    name: "hetReal",
    label: "HET Real (Rp)",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "11%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        const name = tableMeta.rowData[2];
        if (isSaved || name === "Total (Rp)") {
          return val ? FormatCurrencyRupiah({ number: Number(val) }) : null;
        }
        return (
          <SimpleInput
            id="id_input_het_real_part_management_claim"
            box="number"
            containerclassname="width width-120px"
            value={val}
            onValueChange={({ value }) =>
              onChangeData(tableMeta.rowIndex, "hetReal", value)
            }
          />
        );
      },
    },
  },
  {
    name: "ongkosKerja",
    label: (
      <React.Fragment>
        Ongkos Kerja (Rp) <span style={{ color: "red" }}>*</span>
      </React.Fragment>
    ),
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "11%" },
      }),
      customBodyRender: (val, tableMeta) => {
        const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
        const name = tableMeta.rowData[2];
        if (isSaved || name === "Total (Rp)") {
          return val ? FormatCurrencyRupiah({ number: Number(val) }) : null;
        }
        return (
          <SimpleInput
            id="id_input_ongkos_kerja_management_claim"
            box="number"
            value={val}
            containerclassname="width width-120px"
            onValueChange={({ value }) =>
              onChangeData(tableMeta.rowIndex, "ongkosKerja", value)
            }
          />
        );
      },
    },
  },
  {
    name: "isSaved",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (val, { rowIndex, rowData }) => {
        const name = rowData[2];
        if (name === "Total (Rp)") {
          return null;
        }
        return (
          <React.Fragment>
            <FlexView style={{ gap: "15px", marginBottom: "10px" }}>
              {val ? (
                <SimpleButton
                secondary={isDisable}
                  styles={{ width: "unset", marginLeft: "0px" }}
                  onClick={() => {
                    if (!isDisable) {
                      onEditData(rowIndex);
                    }
                  }}
                  disable={isDisable}
                  icon={<i className="fa fa-lw fa-pencil-alt" />}
                />
              ) : (
                <SimpleButton
                secondary={isDisable}
                  styles={{ width: "unset", marginLeft: "0px" }}
                  onClick={() => {
                    if (!isDisable) {
                      onSaveData(rowIndex);
                    }
                  }}
                  disable={isDisable}
                  icon={<i className="fa fa-lw fa-save" />}
                />
              )}
              <SimpleButton
              secondary={isDisable}
                styles={{ width: "unset", marginLeft: "0px" }}
                onClick={() => {
                  if (!isDisable) {
                    onDeleteData(rowIndex);
                  }
                }}
                disable={isDisable}
                icon={<i className="fa fa-lw fa-trash" />}
              />
            </FlexView>
          </React.Fragment>
        );
      },
    },
  },
];
